class TriageQuestion {
  constructor(title, tag, chiefComplaintId) {
    this.title = title;
    this.tag = tag;
    this.chiefComplaintId = chiefComplaintId;
  }
}
export default {
  data() {
    return {
      allTriageQuestions: [],
      triageQuestion: new TriageQuestion('', '', null),
      triageQuestions: null,
      triageQuestionDetail: null,
    };
  },
  methods: {
    getAllTriageQuestionsWithCheifComplaintIdFunction: function (cheifComplaintId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getAllTriageQuestionsWithCheifComplaintId', cheifComplaintId)
        .then(() => {
          if (this.$store.state.triageQuestionModule.successFlag) {
            this.allTriageQuestions = this.$store.state.triageQuestionModule.allTriageQuestions;
            if (this.$route.name == 'addTriageAnswer') {
              this.allTriageQuestions.forEach((c) => (c.class = 'mr-3 mt-2'));
              if (this.$route.params.id) {
                this.selectGoToQuestionItem(this.selectedGoToQuestion);
              }
            }
            if (this.load.val) {
              this.load.val = false;
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.triageQuestionModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getAllTriageQuestionsWithCheifComplaintIdFunction(cheifComplaintId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.triageQuestionModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getAllTriageQuestionsWithCheifComplaintIdFunction(cheifComplaintId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getTriageQuestions: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getTriageQuestions', id).then(() => {
        if (this.$store.state.triageQuestionModule.successFlag) {
          this.triageQuestions = this.$store.state.triageQuestionModule.triageQuestions;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.triageQuestionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getTriageQuestions(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.triageQuestionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getTriageQuestions(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllTriageQuestionsByMissionId: function (missionId) {
      this.load.val = true;
      const params = {
        missionId,
      };
      this.$store
        .dispatch('getAllTriageQuestionsByMissionIdDispatch', params)
        .then(() => {
          if (this.$store.state.triageQuestionModule.successFlag) {
            this.allTriageQuestions = this.$store.state.triageQuestionModule.allTriageQuestions;
          } else {
            if (this.$store.state.triageQuestionModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getAllTriageQuestionsByMissionId(missionId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.triageQuestionModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getAllTriageQuestionsByMissionId(missionId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
    addTriageQuestionRootFunction: function () {
      if (!this.triageQuestion.title) {
        this.snackText = 'عنوان سوال نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.triageQuestion.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان سوال نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      this.triageQuestion.chiefComplaintId = Number(localStorage.getItem('adminCheifComplaint'));
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addTriageQuestionRoot', this.triageQuestion).then(() => {
        if (this.$store.state.triageQuestionModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' سوال با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.triageQuestion = new TriageQuestion('', '', null);
          this.getTriageQuestions(Number(localStorage.getItem('adminCheifComplaint')));
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.triageQuestionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addTriageQuestionRootFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.triageQuestionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addTriageQuestionRootFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addTriageQuestionFunction: function () {
      if (!this.triageQuestion.title) {
        this.snackText = 'عنوان سوال نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.triageQuestion.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان سوال نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      this.triageQuestion.answerId = this.previousAnswerId;
      this.triageQuestion.chiefComplaintId = Number(localStorage.getItem('adminCheifComplaint'));
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addTriageQuestion', this.triageQuestion).then(() => {
        if (this.$store.state.triageQuestionModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' سوال با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.triageQuestion = new TriageQuestion('', '', null);
          this.triageQuestions = this.$store.state.triageQuestionModule.triageQuestions;
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.triageQuestionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addTriageQuestionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.triageQuestionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addTriageQuestionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getTriageQuestionFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getTriageQuestion', id).then(() => {
        if (this.$store.state.triageQuestionModule.successFlag) {
          this.triageQuestion = this.$store.state.triageQuestionModule.triageQuestion;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.triageQuestionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getTriageQuestionFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.triageQuestionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getTriageQuestionFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editTriageQuestionFunction: function () {
      if (!this.triageQuestion.title) {
        this.snackText = 'عنوان سوال نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.triageQuestion.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان سوال نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('editTriageQuestion', this.triageQuestion).then(() => {
        if (this.$store.state.triageQuestionModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.showAddEditModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.mounte();
          this.snackText = ' سوال با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.triageQuestion = new TriageQuestion('', '', null);
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.triageQuestionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editTriageQuestionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.triageQuestionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editTriageQuestionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteTriageQuestionFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteTriageQuestion', this.triageQuestionId).then(() => {
        if (this.$store.state.triageQuestionModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.mounte();
          this.snackText = ' سوال با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.triageQuestionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteTriageQuestionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.triageQuestionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteTriageQuestionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getTriageQuestionWithDetailFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getTriageQuestionWithDetail', id).then(() => {
        if (this.$store.state.triageQuestionModule.successFlag) {
          this.triageQuestionDetail = this.$store.state.triageQuestionModule.triageQuestionDetail;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.triageQuestionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getTriageQuestionWithDetailFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.triageQuestionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getTriageQuestionWithDetailFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getTriageQuestionWithChiefComplaintFunction: function (id) {
      this.$store.dispatch('getTriageQuestionWithCheifComplaintId', id).then(() => {
        if (this.$store.state.triageQuestionModule.successFlag) {
          let temp = this.$store.state.triageQuestionModule.triageQuestionWithChiefComplaint;
          this.changeTriageFromDiagnosis(temp);
        } else {
          if (this.$store.state.triageQuestionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getTriageQuestionWithChiefComplaintFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.triageQuestionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getTriageQuestionWithChiefComplaintFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
  },
};
